<img [ngStyle]="{
    width: '100%',
    height: initOptions.height + 'px'
  }" class="{{ initOptions.style }}" name="{{ initOptions.id }}" id="{{ initOptions.id }}" src="{{ initOptions.src }}">